import { z } from 'zod'
import { optionalText, requiredNumber, requiredText } from '../../../lib/forms/rules'

/**
 * Değerlendirme Skoru düzenleme form şeması (027): nameTr zorunlu; nameEn opsiyonel; startScore/endScore
 * zorunlu tam sayı (≥0); descriptionTr/En opsiyonel (≤1000). Çapraz kural: `endScore > startScore`
 * (`superRefine` → tip bozulmaz, hata `endScore` alanına düşer).
 */
export const criteriaScoreRangeFormSchema = z
  .object({
    nameTr: requiredText(255),
    nameEn: optionalText(255),
    startScore: requiredNumber(),
    endScore: requiredNumber(),
    descriptionTr: optionalText(1000),
    descriptionEn: optionalText(1000),
  })
  .superRefine((v, ctx) => {
    if (v.startScore !== null && v.endScore !== null && v.endScore <= v.startScore) {
      ctx.addIssue({
        code: 'custom',
        message: 'validation.endGreaterThanStart',
        path: ['endScore'],
      })
    }
  })

export type CriteriaScoreRangeFormValues = z.infer<typeof criteriaScoreRangeFormSchema>
